/* eslint-disable */
require('./loader')
require('./no-photo')
